<template>
  <div
    class="form-group"
    :class="{ 'has-error': errors.has(name), 'form-group-active': active }"
  >
    <label class="control-label" v-if="label" v-html="label" />

    <div class="input-group">
      <span class="input-group-addon">
        <slot name="input-group"></slot>
      </span>
      <slot name="input">
        <input
          ref="input"
          :class="['form-control', size]"
          :value="value"
          :type="type"
          :placeholder="placeholder"
          :name="name"
          :min="min"
          :max="max"
          :step="step"
          :readonly="readonly"
          :disabled="disabled"
          :required="required"
          :data-vv-as="label"
          @input="$emit('input', $event.target.value)"
          @blur="$emit('blur', $event.target.value), changeFocus()"
          @focus="changeFocus()"
          @keyup.enter="onEnter()"
        />
      </slot>
    </div>
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
import { EventsGlobal } from "../../../events/eventsGlobal";

export default {
  inject: ["$validator"],
  name: "form-group-input-group",
  props: {
    type: {
      type: String,
      default: "text",
      validate: val => {
        return (
          ["text", "url", "email", "password", "search"].indexOf(val) !== -1
        );
      }
    },
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: String,
    size: String,
    min: String,
    max: String,
    step: String
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    error() {
      return this.errors.has(this.name);
    }
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    },
    onEnter() {
      EventsGlobal.$emit("onEnter", true);
    }
  },
  watch: {
    error(value) {
      if (value)
        setTimeout(function() {
          $('[data-toggle="tooltip"]').tooltip();
        }, 1000);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupInputGroup.vue